/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Shared_Input_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Type a message to create your own copy..." |
*
* @param {Chat_Shared_Input_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_shared_input_placeholder = /** @type {((inputs?: Chat_Shared_Input_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Shared_Input_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nachricht eingeben, um eine eigene Kopie zu erstellen...")
	return /** @type {LocalizedString} */ ("Type a message to create your own copy...")
});